import Vue from 'vue';
let v = Vue.prototype

import auth from './auth';
import chat from './chat';
import nav from './nav';
import users from './users';
import notifications from './notifications';
import content from './content';

const getters = {
	essentialData: (state, getters, rootState, rootGetters) => {
		return {spaceName: rootGetters.getCurrentAreaTitle, spaceId: rootGetters.getCurrentAreaId}
	},
}

const actions = {
	mixpanelIdentify({rootGetters}) {
		v.$mixpanel.identify(rootGetters['current_user/id'])
	},
	mixpanelSetUser({getters}, data) {
		v.$mixpanel.people.set({...getters.essentialData, ...data})
	},
	mixpanelTrack({getters}, [name, data = {}]) {
		v.$mixpanel.track(name, {...getters.essentialData, ...data})
	},
	...auth,
	...chat,
	...nav,
	...users,
	...notifications,
	...content
};

export default {
	// namespaced: true,
	getters,
	actions
};
